.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 0.8rem 1.6rem 0;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid transparent;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  @media screen and (max-width: #{$bp-small - 1}) {
    &:not(:last-child) {
      border-bottom: 0.1rem solid var(--color-grayscale-trout);
    }
  }

  @media screen and (min-width: $bp-small) {
    cursor: pointer;
    border-color: transparent;
    border-radius: 0.4rem;
    background: var(--color-grayscale-eerie-black);
    padding: 0.8rem;

    &[data-selected='true'] {
      border-color: var(--color-primary-crayola);
    }
  }
}

.left {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;

  @media screen and (min-width: $bp-small) {
    gap: 1.6rem;
  }
}

.title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--color-grayscale-anti-flash-white);

  @media screen and (min-width: $bp-small) {
    font-weight: 600;
    color: var(--color-grayscale-white);
  }
}

.profession {
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--color-grayscale-manatee);

  @media screen and (min-width: $bp-small) {
    font-weight: 400;
  }
}

.content {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 3.8rem;
  gap: 0.4rem;
}

.avatar-wrapper {
  flex: 1 0 auto;
  width: 3.2rem;
  height: 3.2rem;

  span {
    &[data-size='fill'] {
      font-size: 1.4rem;
    }
  }

  @media screen and (min-width: $bp-small) {
    width: 4.8rem;
    height: 4.8rem;

    span {
      &[data-size='fill'] {
        font-size: 1.6rem;
      }
    }
  }
}
